import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { changeNavigationState, goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { BOTTOM_NAVIGATION_TYPE, TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';

import YBFraseHead from './YBFraseHead.component';

/** @namespace Elganso/Component/YBFraseHead/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    navigationState: state.NavigationReducer[BOTTOM_NAVIGATION_TYPE].navigationState,
    headerState: state.NavigationReducer[TOP_NAVIGATION_TYPE].navigationState,
    device: state.ConfigReducer.device
});

/** @namespace Elganso/Component/YBFraseHead/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    setNavigationState: (stateName) => dispatch(changeNavigationState(BOTTOM_NAVIGATION_TYPE, stateName)),
    goToPreviousHeaderState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE)),
    goToPreviousNavigationState: () => dispatch(goToPreviousNavigationState(BOTTOM_NAVIGATION_TYPE))
});

/** @namespace Elganso/Component/YBFraseHead/Container */
export class YBFraseHeadContainer extends PureComponent {
    state = {
        cerradoManual: false
    };

    containerFunctions = {
        closeFraseHead: this.closeFraseHead.bind(this)
    };

    containerProps() {
        const { device, navigationState, fraseHeadConfig } = this.props;
        const { cerradoManual } = this.state;

        return {
            device,
            navigationState,
            cerradoManual,
            fraseHeadConfig
        };
    }

    closeFraseHead() {
        this.setState({ cerradoManual: true });
    }

    render() {
        return (
            <YBFraseHead
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(YBFraseHeadContainer);
